export default __webpack_public_path__ + "src/assets/icons/x_icon.png";